import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CarouselIndicators from 'JS/dxp/components/shared/CarouselIndicators.vue';
import ProductCarouselCard from 'JS/components/carousels/ProductCarouselCard.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { getPriceMode } from 'JS/types/Product';
import { IProductCarouselProduct, isHawkCarousel, ProductCarousel } from 'JS/types/Carousel';
import { ListSliderElement, SlideChangeEvent } from 'JS/list-slider';
import { nextTick, onMounted, ref } from 'vue';
import { useProductCarouselTracking } from 'JS/dxp/composables/product-carousel-tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsCarousel',
  props: {
    carousel: null
  },
  setup(__props: any) {

const props = __props as {
	carousel: ProductCarousel;
}



const slider = ref<ListSliderElement>();
const numSlides = ref(0);
const currentSlide = ref(0);

onMounted(() => {
	nextTick(() => {
		// We need to set up our carousel on load to populate our indicators
		numSlides.value = slider.value?.slideCount ?? 0;
		currentSlide.value = slider.value?.slide ?? 0;
	});
});

function handleSlideChange(e: SlideChangeEvent) {
	const { toSlide, slideCount } = e.detail;
	currentSlide.value = toSlide;
	numSlides.value = slideCount;
}

function handleUpdateSlide(slide: number) {
	if (slider.value) {
		slider.value.slide = slide;
	}
}

///////GA Tracking///////
const intersectionObserverOptions = {
	root: null,
	rootMargin: '-150px', //Trigger once 150px of the carousel is in view
};

const { trackView, trackClick } = useProductCarouselTracking(() => ({
	type: props.carousel.carouselType,
	name: props.carousel.name || props.carousel.title,
	products: props.carousel.products.map(product => ({
		blainNumber: product.blainNumber,
		vendorBrand: product.vendorBrand,
		productName: product.name,
		price: product.price,
		belowMap: product.price.isBelowMAP,
		priceMode: getPriceMode(product.price)
	}))
}));

function trackClickHelper(product: IProductCarouselProduct, index: number) {

	const hawkClickData = isHawkCarousel(props.carousel)
		? {
			hawkRequestId: props.carousel.requestId,
			hawkWidgetType: props.carousel.widgetType,
		}
		: null;

	trackClick(
		{
			blainNumber: product.blainNumber,
			price: product.price,
			brand: product.vendorBrand,
			name: product.name,
		},
		index,
		hawkClickData
	);
}


return { __sfc: true,props, slider, numSlides, currentSlide, handleSlideChange, handleUpdateSlide, intersectionObserverOptions, trackView, trackClick, trackClickHelper, CarouselArrowButton, CarouselIndicators, ProductCarouselCard, VIntersectionObserver }
}

})